import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col items-center px-6 py-10 md:px-16 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="max-w-4xl w-full bg-white dark:bg-gray-800 p-6 md:p-10 rounded-lg shadow-lg">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
        <p className="mb-4">
          At <strong>PrintKaro.shop</strong>, we respect your privacy and are committed to
          protecting your personal information.
        </p>

        <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <ul className="mb-4 list-disc pl-5">
          <li>
            <strong>Account Information:</strong> Email, password, and login details (including
            Google authentication).
          </li>
          <li>
            <strong>Uploaded Documents:</strong> Temporarily stored for printing and{" "}
            <strong>permanently deleted after processing</strong>.
          </li>
          <li>
            <strong>Payment Information:</strong> Payments are handled by <strong>Razorpay</strong>;
            we do <strong>not</strong> store card details.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
        <ul className="mb-4 list-disc pl-5">
          <li>To process print orders and provide customer support.</li>
          <li>To improve our services and user experience.</li>
          <li>To ensure account security and prevent fraud.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">3. Data Security & Document Handling</h2>
        <ul className="mb-4 list-disc pl-5">
          <li>
            <strong>Uploaded documents are automatically deleted</strong> after printing.
          </li>
          <li>We use encryption & security measures to protect user data.</li>
          <li>
            We <strong>never share</strong> your data with third parties.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">4. Payment Security</h2>
        <ul className="mb-4 list-disc pl-5">
          <li>
            All payments are securely processed via <strong>Razorpay</strong>.
          </li>
          <li>
            We <strong>do not store</strong> payment details like credit/debit card numbers.
          </li>
          <li>Razorpay ensures PCI-DSS compliance for secure transactions.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">5. Your Rights</h2>
        <ul className="mb-4 list-disc pl-5">
          <li>You can request account deletion anytime.</li>
          <li>You can update your email or password in your account settings.</li>
          <li>
            If you have privacy concerns, contact us at <strong>support@printkaro.shop</strong>.
          </li>
        </ul>

        <h2 className="text-2xl font-semibold mt-6 mb-2">6. Changes to Privacy Policy</h2>
        <p className="mb-4">
          We may update this policy. Continued use of our service indicates acceptance of changes.
        </p>

        <p className="mt-6 text-center text-sm">
          If you have any questions, email us at <strong>printkaro369@gmail.com</strong>.
        </p>

        <div className="mt-6 text-center">
          <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
